'use client';

/**
 * Industry Quote Form
 *
 * Reusable wrapper around <HubSpotForm> for industry pages.
 * Provides consistent styling, env-based configuration, and
 * CSS overrides to match the SCW design system.
 */

import { HubSpotForm } from './HubSpotForm';
import { HUBSPOT_PORTAL_ID, HUBSPOT_QUOTE_FORM_ID } from '@/lib/hubspot-forms';

interface IndustryQuoteFormProps {
  variant?: 'default' | 'light';
  title?: string;
  className?: string;
}

const variantStyles: Record<string, string> = {
  default: 'bg-[#e2e2e2]',
  light: 'bg-[#f5f7f9]',
};

export function IndustryQuoteForm({
  variant = 'default',
  title,
  className,
}: IndustryQuoteFormProps) {
  return (
    <div className={`rounded-sm p-5 shadow ${variantStyles[variant]} ${className ?? ''}`}>
      {title && (
        <h2 className="mb-4 text-[36px] font-semibold leading-[43.2px] text-[#D97B3C]">
          {title}
        </h2>
      )}
      <HubSpotForm
        formId={HUBSPOT_QUOTE_FORM_ID}
        portalId={HUBSPOT_PORTAL_ID}
        className="hubspot-industry-form"
      />
      <style>{`
        .hubspot-industry-form .hs-form input[type="text"],
        .hubspot-industry-form .hs-form input[type="email"],
        .hubspot-industry-form .hs-form input[type="tel"],
        .hubspot-industry-form .hs-form input[type="number"],
        .hubspot-industry-form .hs-form select,
        .hubspot-industry-form .hs-form textarea {
          height: 44px;
          width: 100%;
          border: 1px solid #d4dde6;
          background: #fff;
          padding: 0 12px;
          font-size: 16px;
          color: #374b64;
        }
        .hubspot-industry-form .hs-form textarea {
          height: 86px;
          padding: 12px;
        }
        .hubspot-industry-form .hs-form .hs-button {
          background-color: var(--scw-orange, #ED8326);
          color: #fff;
          border: none;
          padding: 12px 20px;
          font-size: 13px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          cursor: pointer;
          transition: background-color 0.15s;
        }
        .hubspot-industry-form .hs-form .hs-button:hover {
          background-color: var(--scw-orange-hover, #d97520);
        }
        .hubspot-industry-form .hs-form label {
          font-size: 14px;
          font-weight: 600;
          color: #4a6787;
        }
        .hubspot-industry-form .hs-form .hs-error-msgs label {
          font-size: 12px;
          font-weight: 400;
          color: #dc2626;
        }
        .hubspot-industry-form .hs-form fieldset {
          max-width: 100% !important;
        }
        .hubspot-industry-form .hs-form .hs-form-field {
          margin-bottom: 12px;
        }
      `}</style>
    </div>
  );
}
